// extracted by mini-css-extract-plugin
export default {"icon":"heB_ywtnUkc5pOWPKROf","size-lg":"bqh2tMQpDj5ahlwbvoTA","icon-shuffle":"gHAnIrxXMn890yBAHoP0"};